// https://github.com/gatsbyjs/gatsby/issues/4021#issuecomment-445238511
import React from 'react'
import Img from 'gatsby-image/withIEPolyfill'

export default ({ objectFit = 'cover', objectPosition = '50% 50%', ...props }) =>
  <Img objectFit={objectFit} objectPosition={objectPosition} {...props} />
